import { Injectable } from "@angular/core";
import { Subscription, BehaviorSubject } from "rxjs";
import { BreakpointObserver } from "@angular/cdk/layout";
import { MediaObserver, MediaChange } from "@angular/flex-layout";

@Injectable({ providedIn: "root" })
export class MediaWatcherService {
    mediaWatcher: Subscription;

    private isTabletLargeSubject = new BehaviorSubject<boolean>(false);
    public isTabletLarge = this.isTabletLargeSubject.asObservable();

    private isMobilePortraitSubject = new BehaviorSubject<boolean>(false);
    public isMobilePortrait = this.isMobilePortraitSubject.asObservable();

    constructor(media: MediaObserver) {
        this.mediaWatcher = media.media$.subscribe((change: MediaChange) => {
            this.isTabletLargeSubject.next(change.mqAlias === "sm" || change.mqAlias === "xs" || change.mqAlias === "md");

            this.isMobilePortraitSubject.next(change.mqAlias === "xs");
        });
    }
}